import Collection from '../collection';
import Config from '../config';
import Layer from '../model/layer';

export default Collection.extend( {
    getUrl() {
		let url = `layers`;
		for (let name in this.filters) if (this.filters.hasOwnProperty( name ))
            if (undefined !== this.filters[name])
			    url = Config.add( url, name, this.filters[name] );
		
        url = Config.url( url, { addToken: true, addBase: false } );
        if (this.page)
            url = Config.add( url, 'page', this.page );

        return url;
	},
	
	parseResponse(modelsAttrs, response) {
		return modelsAttrs.map( modelAttrs => modelAttrs.layer );
	},

	endpoint: 'layers',
	responseAt: 'layers',
	model: Layer,
	jsonp: false,
} );


// WEBPACK FOOTER //
// ./src/js/collection/layers.js